var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.403 39.9448C20.1822 39.7241 19.7295 39.7241 19.3983 39.9448C18.8353 40.4965 17.9521 40.4965 17.389 39.9448C17.1682 39.7241 16.7156 39.7241 16.3844 39.9448C16.1635 40.1655 16.1635 40.6069 16.3844 40.9379C17.4994 42.0414 19.2879 42.0414 20.403 40.9379C20.6238 40.6069 20.6238 40.1655 20.403 39.9448Z",
    fill: "url(#paint0_linear_486_2012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0055 52.1931L26.7614 49.9862C25.8672 49.5448 24.9729 49.1034 24.2001 48.4414C23.5267 47.8896 23.1955 47.5586 22.6434 46.7862H22.533L22.4226 46.6758H21.981V45.5724C24.6528 44.2483 26.5517 41.4896 26.5517 38.4V35.3103H26.6621C26.6621 35.3103 26.7725 35.3103 26.7725 35.4207H27.3245C27.4349 35.3103 27.5453 35.2 27.6557 35.0896V34.9793C28.55 30.6759 28.2077 27.2552 26.4302 24.8276C25.0944 22.8414 23.4163 22.4 23.4163 22.4C22.9747 22.2896 22.522 22.6207 22.522 23.0621V23.5034C21.4069 23.1724 19.3976 22.731 17.0571 22.731C13.8223 22.8414 9.36209 24.0552 6.91117 29.5724C6.80077 29.9034 7.02156 30.2345 7.24236 30.3448C7.91582 30.5655 9.14129 31.0069 10.2563 31.2276V38.2896C10.2563 41.3793 12.0449 44.1379 14.7166 45.4621V46.5655H14.4958C14.4958 46.5655 14.3854 46.5655 14.3854 46.6758L14.275 46.7862C13.8334 47.4483 13.2703 47.8896 12.4865 48.5517C11.813 49.1034 10.9298 49.5448 10.1459 49.9862L4.90185 52.1931C1.77747 53.5172 0 58.4827 0 61.4621V63.3379C0 63.669 0.331223 64 0.673469 64H36.245C36.5762 64 36.9184 63.669 36.9184 63.3379V61.4621C36.9184 58.4827 35.1299 53.5172 32.0166 52.1931H32.0055ZM14.7166 48.331L17.3883 50.9793L15.5998 53.4069L13.7009 49.3241C14.0321 48.9931 14.3743 48.6621 14.7055 48.331H14.7166ZM22.0804 48.2207C22.4116 48.5517 22.7538 48.8827 23.085 49.2138L21.1861 53.2965L19.3976 50.869L22.0694 48.2207H22.0804ZM17.0571 24.0552C20.0711 23.9448 22.7428 25.0483 22.8532 25.0483H23.1844C23.258 25.0483 23.2948 25.0115 23.2948 24.9379L23.4052 24.8276V24.7172V24.4965V24.1655C24.6307 25.0483 26.64 27.1448 26.1873 32.1103C25.8561 31.4483 25.9666 31.5586 25.9666 31.4483H25.5249L24.7411 31.7793L24.9619 30.8965C25.0723 30.3448 24.5203 29.9034 24.0676 30.1241L21.8375 31.0069L21.9479 30.4552C21.9479 30.2345 21.8375 29.9034 21.6167 29.7931C21.3959 29.6828 21.0647 29.6828 20.8328 29.7931C20.8328 29.7931 17.0461 32.5517 8.5672 29.7931C10.2343 26.0414 13.1378 24.2758 17.0461 24.0552H17.0571ZM11.7137 38.2896V31.669C16.0635 32.4414 18.8456 31.8896 20.4133 31.2276V31.5586C20.3029 32.1103 20.8549 32.4414 21.3076 32.331L23.4273 31.5586L23.2065 32.4414C23.0961 32.9931 23.5377 33.4345 24.1008 33.2138L25.2158 32.8827V38.4C25.2158 42.0414 22.2018 45.0207 18.5254 45.0207C14.7387 44.9103 11.7247 41.931 11.7247 38.2896H11.7137ZM20.5127 46.0138V47.7793L18.393 49.8759L16.1629 47.669V46.0138C17.6091 46.4552 19.0664 46.4552 20.5127 46.0138ZM1.33589 61.4621C1.33589 58.5931 3.12438 54.4 5.3545 53.5172L10.5986 51.3103C11.272 50.9793 11.9345 50.6483 12.6079 50.2069L14.838 55.0621C15.0588 55.5034 15.7323 55.6138 16.0635 55.1724L17.0682 53.9586L14.9484 62.7862H7.81648V58.7034C7.81648 58.3724 7.48525 58.0414 7.14301 58.0414C6.80076 58.0414 6.46957 58.3724 6.46957 58.7034V62.7862H1.56772V61.4621H1.3469H1.33589ZM18.404 53.8483L20.6341 62.7862H16.2843L18.404 53.8483ZM35.4611 62.6759H30.5593V58.5931C30.5593 58.2621 30.2281 57.931 29.8858 57.931C29.5436 57.931 29.2124 58.2621 29.2124 58.5931V62.6759H22.0804L19.9607 54.069L20.7445 55.1724C21.0757 55.6138 21.7492 55.5034 21.97 55.0621L24.3105 50.2069C24.984 50.6483 25.6464 50.9793 26.3198 51.3103L31.5639 53.5172C33.794 54.5103 35.5826 58.5931 35.5826 61.4621L35.4721 62.6759H35.4611Z",
    fill: "url(#paint1_linear_486_2012)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2268 20.6345L59.0978 20.1931C58.877 19.4207 58.5458 18.6482 58.2035 17.9862L60.7649 14.7862C60.9857 14.5655 60.9857 14.1241 60.7649 13.9034L57.4197 10.5931C57.1989 10.3724 56.7462 10.3724 56.5254 10.5931L53.2907 13.131C52.6172 12.8 51.8444 12.4689 51.0605 12.2482L50.6189 8.16549C50.6189 7.83445 50.2877 7.50342 49.9455 7.50342H45.154C44.8228 7.50342 44.4806 7.72411 44.4806 8.16549L44.039 12.2482C43.2551 12.4689 42.4823 12.8 41.8088 13.131L38.5741 10.5931C38.3533 10.3724 37.9006 10.3724 37.6798 10.5931L34.3346 13.9034C34.1138 14.1241 34.1138 14.5655 34.3346 14.7862L36.896 17.9862C36.5648 18.6482 36.2225 19.4207 36.0017 20.1931L31.8727 20.6345C31.5414 20.6345 31.1992 20.9655 31.1992 21.2965V26.0413C31.1992 26.3724 31.42 26.7034 31.8727 26.7034L36.0017 27.1448C36.2225 27.9172 36.5537 28.5793 36.896 29.3517L34.3346 32.5517C34.1138 32.7724 34.1138 33.2138 34.3346 33.4345L37.6798 36.7448C37.9006 36.9655 38.3533 36.9655 38.5741 36.7448L41.8088 34.2069C42.4823 34.5379 43.2551 34.8689 44.039 35.0896L44.4806 39.1724C44.4806 39.5034 44.8118 39.8345 45.154 39.8345H49.9455C50.2767 39.8345 50.6189 39.6138 50.6189 39.1724L51.0605 35.0896C51.8444 34.8689 52.5068 34.5379 53.2907 34.2069L56.5254 36.7448C56.7462 36.9655 57.1989 36.9655 57.4197 36.7448L60.7649 33.4345C60.9857 33.2138 60.9857 32.7724 60.7649 32.5517L58.2035 29.3517C58.5347 28.6896 58.877 27.9172 59.0978 27.1448L63.2268 26.7034C63.558 26.7034 63.9003 26.3724 63.9003 26.0413V21.2965C63.9003 20.9655 63.6795 20.6345 63.2268 20.6345ZM62.5534 25.3793L58.6562 25.8207C58.325 25.8207 58.1042 26.0413 58.1042 26.3724C57.8834 27.3655 57.4307 28.2482 56.9891 29.131C56.8787 29.3517 56.8787 29.6827 57.0995 29.9034L59.5504 32.8827L56.8787 35.3103L53.8647 32.8827C53.6439 32.662 53.3127 32.662 53.0809 32.7724C52.1866 33.3241 51.2924 33.6551 50.2877 33.8758C49.9565 33.9862 49.8461 34.2069 49.7357 34.4276L49.2941 38.2896H45.7281L45.2865 34.4276C45.2865 34.0965 45.0657 33.8758 44.7345 33.8758C43.7298 33.6551 42.8356 33.2138 41.9413 32.7724C41.7205 32.662 41.3893 32.662 41.1575 32.8827L38.1435 35.3103L35.6926 32.8827L38.1435 29.9034C38.3643 29.6827 38.3643 29.3517 38.2539 29.131C37.7019 28.2482 37.3597 27.3655 37.1388 26.3724C37.0284 26.0413 36.8076 25.931 36.5868 25.8207L32.6897 25.3793V21.8482L36.5868 21.4069C36.918 21.4069 37.1388 21.1862 37.1388 20.8551C37.3597 19.862 37.8123 18.9793 38.2539 18.0965C38.3643 17.8758 38.3643 17.5448 38.1435 17.3241L35.6926 14.3448L38.1435 11.9172L41.1575 14.3448C41.3783 14.5655 41.7095 14.5655 41.9413 14.4551C42.8356 13.9034 43.7298 13.5724 44.7345 13.3517C45.0657 13.2414 45.1761 13.0207 45.2865 12.8L45.7281 8.9379H49.2941L49.7357 12.8C49.7357 13.131 49.9565 13.3517 50.2877 13.3517C51.2924 13.5724 52.1866 14.0138 53.0809 14.4551C53.3017 14.5655 53.6329 14.5655 53.8647 14.3448L56.8787 11.9172L59.3296 14.3448L56.8787 17.5448C56.6579 17.7655 56.6579 18.0965 56.7683 18.3172C57.3314 19.2 57.6626 20.0827 57.8834 21.0758C57.9938 21.4069 58.2146 21.5172 58.4354 21.6276L62.3326 22.0689L62.5534 25.3793Z",
    fill: "url(#paint2_linear_486_2012)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6164 16.4413C43.5978 16.4413 40.374 19.6413 40.374 23.6138C40.374 27.5862 43.6088 30.7862 47.6164 30.7862C51.624 30.7862 54.8588 27.5862 54.8588 23.6138C54.8588 19.6413 51.624 16.4413 47.6164 16.4413ZM47.6164 29.462C44.3816 29.462 41.7099 26.8138 41.7099 23.6138C41.7099 20.4138 44.3816 17.7655 47.6164 17.7655C50.8512 17.7655 53.5229 20.4138 53.5229 23.6138C53.5229 26.8138 50.8512 29.462 47.6164 29.462Z",
    fill: "url(#paint3_linear_486_2012)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.487 15.7793C15.9426 15.7793 18.7358 13.0207 18.7358 9.60002C18.7358 6.17933 15.9537 3.42072 12.487 3.42072C9.02041 3.42072 6.23828 6.17933 6.23828 9.60002C6.23828 13.0207 9.02041 15.7793 12.487 15.7793ZM12.487 4.74485C15.1588 4.74485 17.3889 6.95175 17.3889 9.60002C17.3889 12.2483 15.1588 14.4552 12.487 14.4552C9.81531 14.4552 7.58519 12.2483 7.58519 9.60002C7.58519 6.95175 9.81531 4.74485 12.487 4.74485Z",
    fill: "url(#paint4_linear_486_2012)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.84 46.8965C48.4995 46.8965 46.6006 48.7724 46.6006 51.0896C46.6006 53.4069 48.4995 55.2828 50.84 55.2828C53.1805 55.2828 55.0794 53.4069 55.0794 51.0896C55.0794 48.7724 53.0701 46.8965 50.84 46.8965ZM50.84 53.7379C49.2833 53.7379 48.0579 52.5241 48.0579 50.9793C48.0579 49.4345 49.2833 48.2207 50.84 48.2207C52.3967 48.2207 53.6332 49.4345 53.6332 50.9793C53.6332 52.5241 52.2973 53.7379 50.84 53.7379Z",
    fill: "url(#paint5_linear_486_2012)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5857 0C39.1377 0 39.5904 0.441373 39.5904 0.993097C39.5904 1.54482 39.1377 1.9862 38.5857 1.9862C38.0337 1.9862 37.5811 1.54482 37.5811 0.993097C37.5811 0.441373 38.0337 0 38.5857 0Z",
    fill: "url(#paint6_linear_486_2012)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9959 7.61377C63.5479 7.61377 64.0005 8.05515 64.0005 8.60687C64.0005 9.1586 63.5479 9.59998 62.9959 9.59998C62.4439 9.59998 61.9912 9.1586 61.9912 8.60687C61.9912 8.05515 62.4439 7.61377 62.9959 7.61377Z",
    fill: "url(#paint7_linear_486_2012)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3328 41.3793C62.8848 41.3793 63.3374 41.8207 63.3374 42.3724C63.3374 42.9242 62.8848 43.3655 62.3328 43.3655C61.7808 43.3655 61.3281 42.9242 61.3281 42.3724C61.3281 41.8207 61.7808 41.3793 62.3328 41.3793Z",
    fill: "url(#paint8_linear_486_2012)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6424 11.0345C25.1944 11.0345 25.647 11.4759 25.647 12.0276C25.647 12.5793 25.1944 13.0207 24.6424 13.0207C24.0903 13.0207 23.6377 12.5793 23.6377 12.0276C23.6377 11.4759 24.0903 11.0345 24.6424 11.0345Z",
    fill: "url(#paint9_linear_486_2012)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79861 19.3104C4.35062 19.3104 4.80327 19.7517 4.80327 20.3035C4.80327 20.8552 4.35062 21.2966 3.79861 21.2966C3.2466 21.2966 2.79395 20.8552 2.79395 20.3035C2.79395 19.7517 3.2466 19.3104 3.79861 19.3104Z",
    fill: "url(#paint10_linear_486_2012)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57986 42.0414C7.13187 42.0414 7.58448 42.4828 7.58448 43.0345C7.58448 43.5862 7.13187 44.0276 6.57986 44.0276C6.02785 44.0276 5.5752 43.5862 5.5752 43.0345C5.5752 42.4828 6.02785 42.0414 6.57986 42.0414Z",
    fill: "url(#paint11_linear_486_2012)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4881 55.8345C44.0401 55.8345 44.4927 56.2759 44.4927 56.8276C44.4927 57.3793 44.0401 57.8207 43.4881 57.8207C42.9361 57.8207 42.4834 57.3793 42.4834 56.8276C42.4834 56.2759 42.9361 55.8345 43.4881 55.8345Z",
    fill: "url(#paint12_linear_486_2012)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3367 42.0414C32.8887 42.0414 33.3414 42.4828 33.3414 43.0345C33.3414 43.5862 32.8887 44.0276 32.3367 44.0276C31.7847 44.0276 31.332 43.5862 31.332 43.0345C31.332 42.4828 31.7847 42.0414 32.3367 42.0414Z",
    fill: "url(#paint13_linear_486_2012)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_2012",
    x1: 18.3937,
    y1: 39.7793,
    x2: 18.3937,
    y2: 41.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_2012",
    x1: 18.4592,
    y1: 22.3786,
    x2: 18.4592,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_2012",
    x1: 47.5497,
    y1: 7.50342,
    x2: 47.5497,
    y2: 39.8345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_2012",
    x1: 47.6164,
    y1: 16.4413,
    x2: 47.6164,
    y2: 30.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_2012",
    x1: 12.487,
    y1: 3.42072,
    x2: 12.487,
    y2: 15.7793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_2012",
    x1: 50.84,
    y1: 46.8965,
    x2: 50.84,
    y2: 55.2828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_2012",
    x1: 38.5857,
    y1: 0,
    x2: 38.5857,
    y2: 1.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_2012",
    x1: 62.9959,
    y1: 7.61377,
    x2: 62.9959,
    y2: 9.59998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_2012",
    x1: 62.3328,
    y1: 41.3793,
    x2: 62.3328,
    y2: 43.3655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_2012",
    x1: 24.6424,
    y1: 11.0345,
    x2: 24.6424,
    y2: 13.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_2012",
    x1: 3.79861,
    y1: 19.3104,
    x2: 3.79861,
    y2: 21.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_486_2012",
    x1: 6.57984,
    y1: 42.0414,
    x2: 6.57984,
    y2: 44.0276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_486_2012",
    x1: 43.4881,
    y1: 55.8345,
    x2: 43.4881,
    y2: 57.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_486_2012",
    x1: 32.3367,
    y1: 42.0414,
    x2: 32.3367,
    y2: 44.0276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.e431c4be71eda5001b909adad7a543ed.svg";
export { ForwardRef as ReactComponent };